/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteProviderUserRequestDto
 */
export interface InviteProviderUserRequestDto {
    /**
     * Provider email
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    email: string;
    /**
     * Provider specialties
     * @type {Array<string>}
     * @memberof InviteProviderUserRequestDto
     */
    specialties?: Array<string>;
    /**
     * Provider first name
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    firstName: string;
    /**
     * Provider middle name
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    middleName?: string;
    /**
     * Provider last name
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    lastName: string;
    /**
     * Provider phone number
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    phoneNumber: string;
    /**
     * Provider profile image
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    profileImage?: string;
    /**
     * Provider NPI
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    npi: string;
    /**
     * Practice branch id
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    branchId?: string;
    /**
     * Role ID
     * @type {string}
     * @memberof InviteProviderUserRequestDto
     */
    roleId?: string;
}

/**
 * Check if a given object implements the InviteProviderUserRequestDto interface.
 */
export function instanceOfInviteProviderUserRequestDto(value: object): value is InviteProviderUserRequestDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function InviteProviderUserRequestDtoFromJSON(json: any): InviteProviderUserRequestDto {
    return InviteProviderUserRequestDtoFromJSONTyped(json, false);
}

export function InviteProviderUserRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteProviderUserRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'specialties': json['specialties'] == null ? undefined : json['specialties'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'phoneNumber': json['phoneNumber'],
        'profileImage': json['profileImage'] == null ? undefined : json['profileImage'],
        'npi': json['npi'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
    };
}

export function InviteProviderUserRequestDtoToJSON(json: any): InviteProviderUserRequestDto {
    return InviteProviderUserRequestDtoToJSONTyped(json, false);
}

export function InviteProviderUserRequestDtoToJSONTyped(value?: InviteProviderUserRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'specialties': value['specialties'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'profileImage': value['profileImage'],
        'npi': value['npi'],
        'branchId': value['branchId'],
        'roleId': value['roleId'],
    };
}

